import { Component } from "react";
import styled from "styled-components";
import Column from "./Column";
import { StepColorsbackground, CandidateShortlistKanban } from '../types';
import ShortlistService from "../../../../services/shortlist.service";
import { Dispatch, AnyAction, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  clickUpdateShortlistStatusIsReproved,
  clickUpdateShortlistStatusIsSelected
} from '../../../../actions';
import { t } from "../../../../translations/translation.service";

const Container = styled.div`
  background-color: transparent;
  /* like display:flex but will allow bleeding over the window width */
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (max-width: 768px) {
    overflow-x: auto;
  }
`;

const TitleOpportunityContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

const TitleOpportunity = styled.h2`
  font-size: 24px;
  font-weight: 500;
  color: #49545c;
`;

type OpportunityData = {
  idOpportunity: string;
  titulo: string;
  _id: string;
}

interface BoardProps {
  opportunityData: OpportunityData;
  token: string;
  initial: { [key: string]: any[] };
  withScrollableColumns?: boolean;
  shortlistStatusIsSelected: {status: boolean; id: string};
  shortlistStatusIsReproved: {status: boolean; id: string};
}

interface BoardState {
  token: string;
  columns: { [key: string]: any[] };
  ordered: string[];
  updateCandidateStep: Array<CandidateShortlistKanban>;
}

class Board extends Component<BoardProps, BoardState> {
  constructor(props: BoardProps) {
    super(props);
    this.state = {
      token: props.token,
      columns: props.initial,
      ordered: Object.keys(props.initial),
      updateCandidateStep: []
    };
  }

  async componentDidUpdate(prevProps: BoardProps, _prevState: BoardState) {
    let updatedCandidates: { [key: string]: any[] } = {};

    if (prevProps.initial !== this.props.initial) {
  const filteredColumns = Object.keys(this.props.initial).reduce((acc, key) => {
    acc[key] = this.props.initial[key].filter(
      (c: any) => [0, 1, 2].includes(c?.status?.current)
    );
    return acc;
  }, {} as any);

  this.setState({
    columns: filteredColumns,
    ordered: Object.keys(filteredColumns)
  });
}

    if (prevProps.shortlistStatusIsSelected !== this.props.shortlistStatusIsSelected) {
      Object.keys(this.state.columns).forEach((key) => {
        updatedCandidates[key] = this.state.columns[key].map((candidate) => {
          if (candidate._id === this.props.shortlistStatusIsSelected.id) {
            candidate.isSelected = this.props.shortlistStatusIsSelected.status;
            if (this.props.shortlistStatusIsSelected.status) {
              candidate.isReproved = false;
            }
          }
          return candidate;
        }
        );
      });

      this.setState({
        columns: updatedCandidates,
        updateCandidateStep: Object.values(updatedCandidates).flat()
      }, async () => {
        await ShortlistService.updateShortlistkanban(
          this.props.token, this.state.updateCandidateStep
        );
      });
    }

    if (prevProps.shortlistStatusIsReproved !== this.props.shortlistStatusIsReproved) {
      Object.keys(this.state.columns).forEach((key) => {
        updatedCandidates[key] = this.state.columns[key].map((candidate) => {
          if (candidate._id === this.props.shortlistStatusIsReproved.id) {
            candidate.isReproved = this.props.shortlistStatusIsReproved.status;
            if (this.props.shortlistStatusIsReproved.status) {
              candidate.isSelected = false;
            }
          }
          return candidate;
        }
        );
      });

      this.setState({
        columns: updatedCandidates,
        updateCandidateStep: Object.values(updatedCandidates).flat()
      }, async () => {
        await ShortlistService.updateShortlistkanban(
          this.props.token, this.state.updateCandidateStep
        );
      });
    }
  }

  render() {
    const { withScrollableColumns, opportunityData } = this.props;
    const { columns, ordered } = this.state;

    return (
      <Container>
        <TitleOpportunityContainer>
           <TitleOpportunity>{t("Oportunidade")}: {opportunityData.titulo}</TitleOpportunity>
          <span>ID: {opportunityData.idOpportunity}</span>
        </TitleOpportunityContainer>
        {ordered.map((key) => (
          <Column
            key={key}
            title={key}
            candidates={columns[key]}
            isScrollable={withScrollableColumns}
            color={StepColorsbackground[key as keyof typeof StepColorsbackground]}
          />
        ))}
      </Container>
    );
  }
}

const mapStateToProps = (store: {
  shortlistUpdateReducer: {
    shortlistStatusIsSelected: any,
    shortlistStatusIsReproved: any
  };
}) => ({
  shortlistStatusIsSelected: store.shortlistUpdateReducer.shortlistStatusIsSelected,
  shortlistStatusIsReproved: store.shortlistUpdateReducer.shortlistStatusIsReproved,
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => bindActionCreators(
  {
    clickUpdateShortlistStatusIsReproved,
    clickUpdateShortlistStatusIsSelected,
  },
  dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(Board);